export default __webpack_public_path__ + "static/media/303.d29599eb.png";